import {getByUrl} from "./services";

const statusUrl = "api/status-type-list";

export const getAllStatus = async () => {
    try {
        return getByUrl(statusUrl);
    } catch (error) {
        throw error;
    }
};
